import { insightArticleDraft01 } from "./drafts/01-research-market-before-prospect-list.js";
import { companyListArticle } from "./published/02-company-list-not-sales-strategy.js";
import { manufacturersSoutheastAsiaArticle } from "./published/03-manufacturers-southeast-asia.js";

export const INSIGHT_STATES = Object.freeze({
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
  UPDATED: "UPDATED",
  ARCHIVED: "ARCHIVED",
});

// These articles are approved for the local release build. The publication date
// must be added when the website first becomes publicly accessible.
// Draft briefs live separately and do not create routes.
const marketResearchArticle = {
  ...insightArticleDraft01,
  state: INSIGHT_STATES.PUBLISHED,
  isDraft: false,
  draftLabel: undefined,
};

export const insightArticles = [marketResearchArticle, companyListArticle, manufacturersSoutheastAsiaArticle];

export const publishedInsights = insightArticles.filter((article) => article.state === INSIGHT_STATES.PUBLISHED || article.state === INSIGHT_STATES.UPDATED);

export function getPublishedInsight(slug) {
  return publishedInsights.find((article) => article.slug === slug) || null;
}
